import type { FunctionComponent } from 'react';

import { Button, ButtonSize } from '../../../shared/components/button/button';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './verification-documents-button.module.scss';

const style = createStyleHelper(styles, 'verification-documents-button');

export interface IAddMoreDocumentsButtonProps {
    className?: string;
    hollow?: boolean;
    buttonText: JSX.Element | string;
    onClick: () => void;
}

export const VerificationDocumentsButton: FunctionComponent<IAddMoreDocumentsButtonProps> = ({
    className,
    buttonText,
    hollow = false,
    onClick,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            <Button
                size={ButtonSize.MEDIUM}
                type={'button'}
                hollow={hollow}
                onClick={() => onClick()}
            >
                {buttonText}
            </Button>
        </div>
    );
};
